import { render } from "./CustomersTable.vue?vue&type=template&id=7e5c21d6&scoped=true"
import script from "./CustomersTable.vue?vue&type=script&lang=js"
export * from "./CustomersTable.vue?vue&type=script&lang=js"

import "./CustomersTable.vue?vue&type=style&index=0&id=7e5c21d6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e5c21d6"]])

export default __exports__